<app-color-grid-preview *ngIf="canShowColors()" [colors]="colors" [showRgbValues]="showRgbValues"> </app-color-grid-preview>
<app-yarn-type-grid-preview *ngIf="canShowYarnTypes()" [yarnTypes]="yarnTypes" [showFirstRawMaterial]="false"> </app-yarn-type-grid-preview>
